export default [

     {
          path: '/vstintegration',
          name: 'VSTIntegration',
          component: () => import("@/views/Page/VSTIntegration/VSTIntegration.vue"),
           meta: {
               title: 'VSTIntegration',
          },
     }
];